/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Home",
    i18n: "sections.home.title",
    slug: "home",
    icon: "HomeIcon",
  },
  {
    header: "sections.header.learning-info",
    items: [
      {
        name: "จัดการสอน",
        i18n: "sections.courses.nav",
        slug: "courses",
        icon: "VideoIcon",
        submenu: [
          {
            url: '/courses/course-outline',
            name: "Course Outline",
            i18n: "sections.courses.course-outline.nav",
            slug: "course-outline",
          },
          {
            url: "/courses/vdo-set",
            name: "VDO Set",
            i18n: "sections.courses.vdo-set.nav",
            slug: "vdo-set",
          },
          {
            url: "/courses/live-class-schedule",
            name: "Live Schedule",
            i18n: "sections.courses.live-class-schedule.nav",
            slug: "live-class-schedule",
          },
          {
            url: "/courses/live-class-schedule-upload",
            name: "Live Schedule Upload",
            i18n: "sections.courses.live-class-schedule-upload.nav",
            slug: "live-class-schedule",
          },
          {
            url: "/courses/vdo-live-set",
            name: "Vdo Live Set",
            i18n: "sections.courses.vdo-live-set.nav",
            slug: "vdo-live-set",
          },
          {
            url: "/courses/advisor-online-schedule",
            name: "Advisor Online Schedule",
            i18n: "sections.courses.advisor-online-schedule.nav",
            slug: "advisor-online-schedule",
          },
        ]
      },
      {
        name: "จัดการลงทะเบียน",
        i18n: "sections.registration.nav",
        slug: "registration",
        icon: "CheckSquareIcon",
        submenu: [
          {
            url: "/registration/course-outline-registration",
            name: "รายวิชาที่เปิดให้ลงทะเบียน",
            i18n: "sections.registration.course-outline-registration.nav",
            slug: "course-outline-registration"
          },
          {
            name: "ลงทะเบียนเรียน",
            url: "/registration/student-enroll",
            i18n: "sections.registration.student-enroll.nav",
            slug: "student-enroll",
          },
          {
            name: "อัพโหลดไฟล์ลงทะเบียน",
            url: "/registration/student-enroll-upload",
            i18n: "sections.registration.student-enroll-upload.nav",
            slug: "student-enroll-upload",
          }
        ]
      },
      {
        name: "จัดการข้อสอบ",
        i18n: "sections.examination.nav",
        slug: "examination",
        icon: "BookIcon",
        submenu: [
          {
            url: "/examination/exam",
            name: "รายวิชาในคลังข้อสอบ",
            i18n: "sections.examination.exam.nav",
            slug: "examination-list"
          },
          {
            url: "/examination/exam-upload",
            name: "อัพโหลดข้อสอบ",
            i18n: "sections.examination.exam-upload.nav",
            slug: "exam-upload"
          }
        ]
      },
      {
        name: "อัพโหลด",
        i18n: "sections.upload.nav",
        slug: "upload",
        icon: "UploadIcon",
        submenu: [
          {
            url: "/upload/live-class-record",
            name: "บันทึกการเข้าบรรยายสด",
            i18n: "sections.upload.yea-link.live-class-record.nav",
            slug: "live-class-record"
          },
          {
            url: "/upload/advisor-online-record",
            name: "บันทึกการพบอาจารย์",
            i18n: "sections.upload.yea-link.advisor-online-record.nav",
            slug: "advisor-online-record"
          },
        ]
      },
    ]
  },
  {
    header: "sections.header.personal-info",
    items: [
      {
        url: "/personal-info",
        name: "ข้อมูลรายบุคคล",
        i18n: "sections.personal-info.nav",
        slug: "personal-info",
        icon: "UserIcon",
        submenu: [
          {
            url: '/personal-info/student',
            name: "ข้อมูลนิสิต",
            i18n: "sections.personal-info.student-profile.nav",
            slug: "personal-info-student",
          },
          {
            url: '/personal-info/student-upload',
            name: "อัพโหลดข้อมูลนิสิต",
            i18n: "sections.personal-info.student-upload.nav",
            slug: "personal-info-student-upload",
          },
          {
            url: '/personal-info/teacher',
            name: "ข้อมูลอาจารย์",
            i18n: "sections.personal-info.teacher-profile.nav",
            slug: "personal-info-teacher",
          },
          {
            url: '/personal-info/teacher-upload',
            name: "อัพโหลดข้อมูลอาจารย์",
            i18n: "sections.personal-info.teacher-upload.nav",
            slug: "personal-info-teacher-upload",
          },
          {
            url: '/personal-info/staff',
            name: "ข้อมูลเจ้าหน้าที่",
            i18n: "sections.personal-info.staff-profile.nav",
            slug: "personal-info-staff",
          },
        ]
      },
    ]
  },
  {
    header: 'sections.header.university-news',
    items: [
      {
        name: "ประกาศจากมหาวิทยาลัย",
        i18n: "sections.university-news.nav",
        slug: "university-news",
        icon: "InfoIcon",
        submenu: [
          {
            url: "/university-news/info-group",
            name: "ประเภทของประกาศ",
            i18n: "sections.university-news.info-group.nav",
            slug: "info-group"
          },
          {
            url: "/university-news/info-topic",
            name: "จัดการเนื้อหา",
            i18n: "sections.university-news.info-topic.nav",
            slug: "info-topic"
          },
        ]
      },
    ]
  },
  {
    header: 'sections.header.report',
    items: [
      {
        name: "รายงาน",
        i18n: "sections.report.nav",
        slug: "report",
        icon: "BarChartIcon",
        submenu: [
          /*{
            url: "/report/student-stat",
            name: "สถิติการเข้าเรียน",
            i18n: "sections.report.student-stat.nav",
            slug: "student-stat"
          },*/
          {
            url: "/report/live-class-schedule",
            name: "รายงานบรรยายสด",
            i18n: "sections.report.live-class-schedule.nav",
            slug: "live-class-schedule"
          },
          {
            url: "/report/exam",
            name: "รายงานจำนวนข้อสอบ",
            i18n: "sections.report.exam.nav",
            slug: "exam"
          },
          {
            url: "/report/exam-question",
            name: "รายงานข้อสอบรายวิชา",
            i18n: "sections.report.exam-question.nav",
            slug: "exam-question"
          },
        ]
      },
    ]
  },
  {
    header: "sections.header.system-info",
    items: [
      {
        name: "ข้อมูลการศึกษา",
        i18n: "sections.common-data.education.nav",
        slug: "common-data",
        icon: "BoxIcon",
        submenu: [
          {
            url: "/common-data/degree",
            name: "ระดับการศึกษา",
            i18n: "common-data.degree",
            slug: "degree"
          },
          {
            url: "/common-data/faculty",
            name: "คณะ",
            i18n: "common-data.faculty",
            slug: "faculty"
          },
          {
            url: "/common-data/department",
            name: "สาขา",
            i18n: "common-data.department",
            slug: "department"
          },
          {
            url: "/common-data/curriculum",
            name: "หลักสูตร",
            i18n: "common-data.curriculum",
            slug: "curriculum"
          },
          {
            url: "/common-data/subject-group",
            name: "กลุ่มวิชา",
            i18n: "common-data.subject-group",
            slug: "subject-group"
          },
          {
            url: "/common-data/subject",
            name: "วิชา",
            i18n: "common-data.subject",
            slug: "subject"
          },
        ]
      },
      {
        name: "ข้อมูลทั่วไป",
        i18n: "sections.common-data.nav",
        slug: "common-data",
        icon: "SettingsIcon",
        submenu: [
          {
            url: "/common-data/academic-period",
            name: "ปีการศึกษา",
            i18n: "common-data.academic-period",
            slug: "academic-period"
          },
          {
            url: "/common-data/assessment",
            name: "หลักเกณฑ์",
            i18n: "common-data.assessment",
            slug: "assessment"
          },
          {
            url: "/common-data/prefix",
            name: "คำนำหน้า",
            i18n: "common-data.prefix",
            slug: "prefix"
          },
          {
            url: "/common-data/project",
            name: "โครงการ",
            i18n: "common-data.project",
            slug: "project"
          },
          {
            url: "/common-data/student-status",
            name: "สถานะภาพนิสิต",
            i18n: "common-data.student-status",
            slug: "student-status"
          },
        ]
      },
      {
        name: "ข้อมูลผู้ใช้ระบบ",
        i18n: "sections.system.title",
        slug: "system",
        icon: "UsersIcon",
        submenu: [
          {
            url: "/system/reset-password",
            name: "รีเซ็ตรหัสผ่าน",
            i18n: "sections.system.reset-password.title",
            slug: "reset-password"
          },
        ]
      },
      {
        name: "ข้อมูลระบบ",
        i18n: "sections.system.system-config.title",
        slug: "system",
        icon: "SettingsIcon",
        submenu: [
          {
            url: "/system/system-config",
            name: "ข้อมูลระบบ",
            i18n: "sections.system.system-config.title",
            slug: "system-config"
          },
        ]
      },
      {
        name: "จัดการห้องเรียน",
        i18n: "class-room.nav",
        slug: "classRoom",
        icon: "ServerIcon",
        submenu: [
          {
            url: "/class-room/class-room-owned",
            name: "ห้องเรียนที่มี",
            i18n: "class-room-owned.class-room-owned",
            slug: "classRoomOwnedList"
          },
          {
            url: "/class-room/class-room",
            name: "ห้องเรียน",
            i18n: "class-room.class-room",
            slug: "classRoomList"
          },
          {
            url: "/class-room/class-room-type",
            name: "ประเภทห้องเรียน",
            i18n: "class-room-type.class-room-type",
            slug: "classRoomTypeList"
          }
        ]
      },
      {
        url: "/system/vdo-migration",
        name: "Bunny Migration",
        i18n: "sections.vdo-migration.nav",
        slug: "vdo-migration",
        icon: "ActivityIcon",
        // Filtered by src/utils/nav-menu-visibility.js. This hides the entry;
        // it does NOT protect the page. The backend resolver is the gate.
        visibleTo: ["admin", "adminNation"],
      },
    ]
  },
]
